import { useSelector } from 'react-redux';
import {
  getViajaAhorrandoDiscountMap,
  isViajaAhorrandoActive,
} from 'selectors/viajeAhorrandoSelector';

/**
 * Hook to get Viaja Ahorrando discount for a specific trip.
 * Uses a map for O(1) lookup performance (no array.find()).
 *
 * @param {string} tripId - The trip ID to search for
 * @returns {Object|null} Viaja Ahorrando discount object or null if not found
 */
const useViajaAhorrandoTrip = (tripId) => {
  const isActive = useSelector(isViajaAhorrandoActive);
  const discountMap = useSelector(getViajaAhorrandoDiscountMap);

  if (!isActive || !tripId || !discountMap) {
    return null;
  }

  return discountMap[tripId] || null;
};

export default useViajaAhorrandoTrip;
